import React, { useState, useEffect } from 'react';

import API from '../services/api';

import { useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';

import '../App.css';



const VerifyEmail = () => {

    const [code, setCode] = useState('');

    const [loading, setLoading] = useState(false);

    const [resending, setResending] = useState(false);

    const [timer, setTimer] = useState(0);

    const navigate = useNavigate();

    

    const email = localStorage.getItem('userEmail');



    useEffect(() => {

        let interval;

        if (timer > 0) {

            interval = setInterval(() => setTimer((prev) => prev - 1), 1000);

        }

        return () => clearInterval(interval);

    }, [timer]);



    const handleResendCode = async () => {

        if (!email) return toast.error("Email not found. Please sign up again.");

        setResending(true);

        try {

            // Backend route updated to /resend-otp

            await API.post(`/resend-otp?email=${email}`); 

            toast.success("New verification code sent!");

            setTimer(60); 

        } catch (error) {

            toast.error("Failed to resend code.");

        } finally {

            setResending(false);

        }

    };



    const handleVerify = async (e) => {

        e.preventDefault();

        setLoading(true);

        try {

            // Matching the new backend route and params

            await API.post(`/verify-email?email=${email}&code=${code}`);

            toast.success("Email verified successfully! Please login.");

            navigate('/login');

        } catch (error) {

            toast.error(error.response?.data?.detail || "Verification failed");

        } finally {

            setLoading(false);

        }

    };



    return (

        <div className="main-bg">

            <div className="brand-section">

                <h1>Cortex</h1>

                <p>One step away!<br/>Verify your identity to unlock your space.</p>

            </div>



            <div className="auth-container">

                <h2>Verify Identity</h2>

                <p className="sub-text" style={{ color: 'white', marginBottom: '40px', letterSpacing: '2px' }}>

                    Authorization Required

                </p>

                

                <form onSubmit={handleVerify}>

                    <input 

                        type="text" 

                        placeholder="Enter 6-Digit Code" 

                        value={code}

                        onChange={(e) => setCode(e.target.value)} 

                        maxLength="6"

                        required 

                    />

                    <button type="submit" disabled={loading}>

                        {loading ? (

                            <>

                                <span className="spinner"></span>

                                Verifying...

                            </>

                        ) : "Confirm Code"}

                    </button>

                </form>



                <div style={{ marginTop: '25px', textAlign: 'center' }}>

                    <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px' }}>

                        Didn't receive the code?{' '}

                        {timer > 0 ? (

                            <span style={{ color: '#00d2ff', fontWeight: 'bold' }}>{timer}s</span>

                        ) : (

                            <span 

                                className="white-link" 

                                onClick={handleResendCode} 

                                style={{ cursor: resending ? 'not-allowed' : 'pointer' }}

                            >

                                {resending ? (

                                    <>

                                        <span className="spinner" style={{ width: '12px', height: '12px', borderWidth: '2px', marginRight: '5px' }}></span>

                                        Sending...

                                    </>

                                ) : "Resend Now"}

                            </span>

                        )}

                    </p>

                </div>

            </div>

        </div>

    );

};



export default VerifyEmail;